export const checkoutScheduledReplenishment = {
	checkoutScheduledReplenishment: {
		autoReplenishOrder: 'Auto Replenishment Orders',
		every: 'Every # Of Days'
	}
};